import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Weird polka",
  "description": "",
  "published": "2007-04-05T00:00:00.000Z",
  "redirect_from": ["/blog/weird-polka/swizec/241"],
  "categories": "funny, linkages, video",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`I don't know what is wrong with Weird Al but he won't stop polkaing good music. The embedded video is of a collage of things he polkad in one of his songs matched synchronised perfectly with the originals. It's something you have to love, just have to.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      